/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useSiteData } from "../context/SiteDataContext";
import staticData from "../data/author.json";

const Authorv3 = ({isBg}) => {
  const { data: siteData, loading } = useSiteData();
  
  // Use context data if available, fallback to static JSON
  const authorv3 = siteData?.authorConfig || staticData.authorv3;

  if (loading) {
    return <section id="author" className="section-padding authorv3"><div className="container"><p>Chargement...</p></div></section>;
  }

  return (
    <section id="author" className={`section-padding authorv3 ${isBg === "yes" ? "bg-one": "" }`}>
      <div className="container">
        <div className="row">
          <div
            className="col-lg-6"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="author-image">
              <img className="img-fluid" src={authorv3.image} alt="" />
            </div>
          </div>
          <div
            className="col-lg-6"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="authorv3__content">
              <div className="authorv3__content--badge">
                {authorv3.subtitle}
              </div>
              <h3 className="display-5 mb-0">{authorv3.title}</h3>
              <p className="m-30px-b text-muted fs-5">{authorv3.text}</p>
              <p 
                className="m-30px-b"
                dangerouslySetInnerHTML={{ __html: authorv3.description }}
              />
              <ul className="social-icon mt-0 mb-0">
                {authorv3.social?.map((socialItem, i) => (
                  <li key={i}>
                    {socialItem.link === "" ? (
                      ""
                    ) : (
                      <a href={socialItem.link}>
                        <img
                          className="img-fluid"
                          src={socialItem.icon}
                          alt="icon"
                          width="25"
                          height="25"
                        />
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Authorv3;
